<template>
  <div class="ap-stats">
    <span v-for="stat in stats" :key="stat.icon + stat.unit" class="ap-stat">
      <span class="material-icons ap-stat__icon" :style="{ color }">{{ stat.icon }}</span>
      {{ stat.value }} <small>{{ stat.unit }}</small>
    </span>
  </div>
</template>

<script setup lang="ts">
import type { ActivityStat } from '../../../utils/recordingActivity/activityPanel';

defineProps<{ stats: ActivityStat[]; color: string }>();
</script>

<style scoped>
.ap-stats {
  display: flex;
  align-items: center;
  gap: 16px;
  white-space: nowrap;
}

.ap-stat {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.95rem;
}

.ap-stat__icon {
  font-size: 16px;
}

.ap-stat small {
  color: var(--text-muted, #b2b2b2);
}
</style>
